export default "__VITE_ASSET__CFJRkUCD__"